import { ConversionUtil } from "@mcleod/core";
import { AutogenModelAuthArControl, AutogenRowAuthArControl, RowAuthArControlFields } from "./autogen/AutogenModelAuthArControl";
import { LMEGeneralSettings } from "@mcleod/general";

export class ModelAuthArControl extends AutogenModelAuthArControl<RowAuthArControl> {
	constructor() {
		super(RowAuthArControl);
	}
}

export function getARControlBoolean(field: keyof RowAuthArControlFields, valueIfNull: boolean = false): boolean {
    const result = getARControlValue(field);
    if (typeof result === "string")
        return ConversionUtil.parseBoolean(result);
    return result ?? valueIfNull;
}

export function getARControlValue(field: keyof RowAuthArControlFields): any {
    return LMEGeneralSettings.getSingleton().getARControl()[field];
}

export class RowAuthArControl extends AutogenRowAuthArControl {
}
